import { useFragment } from "react-relay"
import { Badge } from "@/components/ui/badge"
import { ChatThreadItemFragment$key } from "@/modules/chats/services/fragments/__generated__/ChatThreadItemFragment.graphql"
import { ChatThreadItemFragment } from "@/modules/chats/services/fragments/ChatThreadItemFragment"
import { UNREAD_MESSAGE_THRESHOLD } from "@/modules/chats/types/chat-thread"

type ChatThreadUnreadMessageProps = {
  appointmentRef: ChatThreadItemFragment$key
}

export const ChatThreadUnreadMessage = (props: ChatThreadUnreadMessageProps) => {
  const data = useFragment<ChatThreadItemFragment$key>(ChatThreadItemFragment, props.appointmentRef)

  const unreadMessagesCount = data.chat?.readState?.unreadCount ?? 0
  const lastMessageContent = data.chat?.lastMessage.content

  return (
    <div className="flex h-full justify-between text-xs leading-4">
      <div className="line-clamp-2" data-testid="chat-thread-last-sent-message">
        {lastMessageContent}
      </div>
      {unreadMessagesCount > 0 && (
        <Badge
          className="bg-critical text-on-critical hidden h-4 w-fit min-w-4 content-center justify-center border-0 px-1 py-0 font-normal tracking-[0.375px] @md:flex"
          data-testid="unread-messages-count">
          {unreadMessagesCount > UNREAD_MESSAGE_THRESHOLD ? `${UNREAD_MESSAGE_THRESHOLD}+` : unreadMessagesCount}
        </Badge>
      )}
    </div>
  )
}
